import React, { Component } from "react";
// import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import classNames from "classnames";
import "./style.scss";
// import createStore from "../../redux/store/store";
import { connect } from "react-redux";
// import config from "../../temp/config";
// import axios from 'axios'
import Modal from "../../components/Modal";

class IframeModal extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      iframeHeight: 500,
      IframeSrc: this.props.isIframe && this.props.isIframe.href ? this.props.isIframe.href : ""
    };
  }
  close = event => {
    if (event) {
      event.preventDefault();
    }
    this.props.toggleIframe();
    // window.history.replaceState(null, null, window.location.pathname);
    // console.log(this.props);
    // let elem = document.getElementById(this.props.id);
    // elem.scrollTo(0, 0);
    // elem.classList.add("hide-modal");
    // elem.classList.remove("show-modal");
    // document.body.classList.remove("show-modal");
  };
  addURLParameter() {
    let IframeSrc = this.state.IframeSrc;
    if (IframeSrc.search(window.location.host)) {
      let arr = this.state.IframeSrc.split("/");
      let str = arr[arr.length - 1];
      arr = str.split("?");
      if (str.search("/?/") === "-1") {
        IframeSrc += "&noHeaderFooter=true";
      } else {
        IframeSrc += "?noHeaderFooter=true";
      }
      this.setState({
        IframeSrc: IframeSrc
      });
    }
  }
  changeIframe = e => {
    if (e.origin !== window.location.origin) {
      return false;
    }
    if (e.data > 500) {
      this.setState({
        iframeHeight: e.data
      });
    }
  };
  componentDidMount() {
    let elem = document.getElementById(this.props.id);
    if (elem) {
      elem.addEventListener("scroll", this.handleScroll);
    }
    document.addEventListener("click", this.outsideClick);
    this.addURLParameter();
    window.addEventListener("message", this.changeIframe, false);
  }

  componentWillUnmount() {
    let elem = document.getElementById(this.props.id);
    if (elem) {
      elem.removeEventListener("scroll", this.handleScroll);
    }
    document.removeEventListener("click", this.outsideClick);
    window.removeEventListener("message", this.changeIframe, false);
  }
  handleScroll = event => {
    let elem = document.getElementById(this.props.id);
    if (elem === undefined) {
      return;
    }
    let rect = elem.getBoundingClientRect();

    if (rect.bottom - 299 > this.refs.content.getBoundingClientRect().bottom) {
      if (elem.scrollTo) {
        elem.scrollTo(0, 0);
      } else {
        elem.scrollTop = 0;
        elem.scrollLeft = 0;
      }
      this.close();
    }
  };
  outsideClick = e => {
    if (!e.target.contains) {
      return false;
    }
    if (e.target.contains(this.refs.content)) {
      // console.log('click outside')
      this.close(e);
    }
  };
  render() {
    const modalClasses = classNames("iframe-name", this.props.className);
    return (
      <Modal className={modalClasses} id={this.props.id} onCloseClicked={evt => this.close(evt)} showModal={this.props.show}>
        {this.props.isIframe && this.props.isIframe.href ? (
          <div ref={"content"}>
            <iframe id={"reactComIframe"} src={this.state.IframeSrc} frameBorder="0" style={{ width: "100%", height: this.state.iframeHeight }} />
          </div>
        ) : (
          <div ref={"content"}>{this.props.children}</div>
        )}
      </Modal>
    );
  }
}
const mapStateToProps = state => {
  return {
    // isIframe: state.isIframe,
    // isNestedGrid: state.isNestedGrid
  };
};

export default connect(mapStateToProps, null)(IframeModal);
